import React from 'react'
import ContactForm from './ContactForm'
import UserTicketsModal from './UserTicketsModal'
import DictamenPreview from './previsional/DictamenPreview'

export default function AppModals({
  showSupportModal,
  setShowSupportModal,
  showTicketsModal,
  setShowTicketsModal,
  showDictamen,
  setShowDictamen,
  dictamenLoading,
  dictamenText,
  dictamenVerificationCode,
  contextoDictamen,
  mutationsLog,
  showCoinsGate,
  setShowCoinsGate,
  coinsGateRequired,
  cuit,
  COINS_POR_CALCULO,
  modoHerramienta,
  calculoReady,
  onGenerarCalculo,
  showCalculoConfirm,
  setShowCalculoConfirm,
  calculoLoading,
  showTareasCuidadoModal,
  setShowTareasCuidadoModal,
  expediente,
  titularCuilOrigen,
  aniosTareasCuidado,
  rowsVista,
  shadowBilling,
  scoreCertezaInforme,
  conciliacionManualActa,
  goToStep,
}) {
  return (
    <>
      {showSupportModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/70 p-4 backdrop-blur-sm" onClick={() => setShowSupportModal(false)}>
          <div className="panel-profile relative max-h-[90vh] w-full max-w-3xl overflow-y-auto rounded-3xl p-4 backdrop-blur-2xl" onClick={(e) => e.stopPropagation()}>
            <ContactForm onClose={() => setShowSupportModal(false)} />
          </div>
        </div>
      )}
      {showTicketsModal && <UserTicketsModal onClose={() => setShowTicketsModal(false)} />}
      <DictamenPreview
        open={showDictamen}
        loading={dictamenLoading}
        text={dictamenText}
        verificationCode={dictamenVerificationCode}
        modoDocumento={modoHerramienta}
        rowsForAnnex={rowsVista}
        titularNombre={`${expediente.apellido || ''} ${expediente.nombre || ''}`.trim()}
        titularCuil={titularCuilOrigen || expediente.cuilCuit}
        titularDni=""
        tareasCuidadoResumen={{
          hijos: Number(expediente.cantidadHijos || 0),
          hijosAnios: Number(expediente.cantidadHijos || 0),
          discapacidadAuHCantidad: Number(expediente.hijosDiscapacidad || 0) + (expediente.cobraAUH === 'si' ? 1 : 0),
          discapacidadAuHAnios: Number(expediente.hijosDiscapacidad || 0) + (expediente.cobraAUH === 'si' ? 1 : 0),
          totalAnios: aniosTareasCuidado,
        }}
        includeAdvancedInterestColumn={true}
        hojaDeTrabajo={contextoDictamen?.hojaDeTrabajo}
        proyeccion={contextoDictamen?.proyeccion}
        resumenEjecutivo={contextoDictamen?.resumenEjecutivo}
        defensaJudicial={contextoDictamen?.defensaJudicial}
        metodologiaSintetica={contextoDictamen?.metodologiaSintetica}
        integridad={contextoDictamen?.integridad}
        puntosRechazoPotenciales={contextoDictamen?.puntosRechazoPotenciales}
        anexosTecnicos={contextoDictamen?.anexosTecnicos}
        fundamentosPorLinea={contextoDictamen?.fundamentosPorLinea}
        consistenciaJuridica={contextoDictamen?.consistenciaJuridica}
        preEmisionAudit={contextoDictamen?.preEmisionAudit}
        shadowBilling={shadowBilling}
        scoreCertezaInforme={scoreCertezaInforme}
        conciliacionManualActa={conciliacionManualActa}
        mutationsLog={mutationsLog}
        onClose={() => setShowDictamen(false)}
      />
      {showCoinsGate && (
        <div className="fixed inset-0 z-[75] flex items-center justify-center bg-slate-950/70 p-4 backdrop-blur-sm" onClick={() => setShowCoinsGate(false)}>
          <div className="panel-profile w-full max-w-md rounded-3xl p-5 text-center backdrop-blur-2xl" onClick={(e) => e.stopPropagation()}>
            <p className="text-lg font-semibold text-white">Saldo insuficiente de coins</p>
            <p className="mt-2 text-sm text-slate-300">Necesitas al menos {coinsGateRequired} coin{coinsGateRequired !== 1 ? 's' : ''} para continuar.</p>
            <div className="mt-4 flex justify-center gap-2">
              <button type="button" onClick={() => setShowCoinsGate(false)} className="panel-profile rounded-xl px-4 py-2 text-sm">Cancelar</button>
              <button type="button" onClick={() => { setShowCoinsGate(false); window.location.href = `/coins?user=${encodeURIComponent(cuit)}` }} className="panel-profile-warn rounded-xl px-4 py-2 text-sm font-semibold text-profile-warn">Cargar coins</button>
            </div>
          </div>
        </div>
      )}

      {showCalculoConfirm && (
        <div className="fixed inset-0 z-[76] flex items-center justify-center bg-slate-950/70 p-4 backdrop-blur-sm" onClick={() => setShowCalculoConfirm(false)}>
          <div className="w-full max-w-xl rounded-2xl border border-white/20 bg-slate-900/95 p-5 text-slate-100" onClick={(e) => e.stopPropagation()}>
            <p className="text-lg font-semibold text-white">Confirmar generación de cálculo</p>
            <p className="mt-2 text-sm text-slate-200">
               Asegurate que los valores de la tabla estén correctos antes de continuar porque se descontarán <strong>{COINS_POR_CALCULO} Coins</strong>.
            </p>
            {calculoReady && (
              <p className="mt-2 text-xs text-amber-200">
                Ya existe un cálculo generado. Si recalculás, se descontarán nuevamente {COINS_POR_CALCULO} coins.
              </p>
            )}
            <div className="mt-4 flex justify-end gap-2">
              <button
                type="button"
                onClick={() => setShowCalculoConfirm(false)}
                className="panel-profile rounded-xl px-4 py-2 text-sm"
              >
                Seguir modificando
              </button>
              <button
                type="button"
                onClick={async () => {
                  try {
                    await onGenerarCalculo()
                  } finally {
                    setShowCalculoConfirm(false)
                  }
                }}
                className="btn-profile-soft rounded-xl px-4 py-2 text-sm font-semibold"
                disabled={calculoLoading}
              >
                {calculoLoading ? 'Generando cálculo...' : 'Generar cálculo'}
              </button>
            </div>
          </div>
        </div>
      )}
      {showTareasCuidadoModal && (
        <div className="fixed inset-0 z-[76] flex items-center justify-center bg-slate-950/70 p-4 backdrop-blur-sm" onClick={() => setShowTareasCuidadoModal(false)}>
          <div className="panel-profile w-full max-w-xl rounded-3xl p-5 backdrop-blur-2xl" onClick={(e) => e.stopPropagation()}>
            <p className="text-lg font-semibold text-white">Se detectaron periodos sin aportes</p>
            <p className="mt-2 text-sm text-slate-200">Desea aplicar el reconocimiento por Tareas de Cuidado (Hijos/Discapacidad)?</p>
            <p className="mt-2 text-xs text-slate-300">Si corresponde, cargue los datos en Paso 2 para integrar el computo conforme Decreto 475/2021.</p>
            <div className="mt-4 flex justify-end gap-2">
              <button type="button" onClick={() => setShowTareasCuidadoModal(false)} className="panel-profile rounded-xl px-4 py-2 text-sm">Cerrar</button>
              <button type="button" onClick={() => { setShowTareasCuidadoModal(false); goToStep(2); }} className="btn-profile-soft rounded-xl px-4 py-2 text-sm font-semibold">Ir al Paso 2</button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
